<template>
  <div :class="['timer', remainingColorClass, expiredClass]">
    {{ $t("time_to_done", { seconds: timerSeconds }) }}
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getters } from "@/store";

export default {
  data() {
    return {
      timerValue: null,
      timerInterval: null
    };
  },
  computed: {
    ...mapGetters([getters.currentIdentification]),
    finishDeadline() {
      return this.currentIdentification?.finishDeadlineUtc;
    },
    timerSeconds() {
      return Math.floor(this.timerValue / 1000);
    },
    remainingColorClass() {
      if (this.timerSeconds > 90) {
        return "success";
      } else if (this.timerSeconds > 60) {
        return "warning";
      }
      return "danger";
    },
    expiredClass() {
      return this.timerSeconds <= 0 ? "expired" : "";
    }
  },
  watch: {
    finishDeadline: {
      handler() {
        this.initTimer();
      },
      immediate: true
    }
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
    this.timerInterval = null;
  },
  methods: {
    updateTimer() {
      this.timerValue = new Date(this.finishDeadline).getTime() - Date.now();
    },
    initTimer() {
      clearInterval(this.timerInterval);
      this.timerInterval = null;

      if (!this.finishDeadline) {
        this.timerValue = null;
        return;
      }

      this.updateTimer();
      this.timerInterval = setInterval(this.updateTimer, 1000);
    }
  }
};
</script>

<style scoped lang="scss">
@keyframes expired {
  0% {
    color: var(--text-color-base);
  }
  100% {
    color: var(--text-danger);
    text-shadow: 0 0 0.3rem currentColor;
  }
}
.timer {
  font-weight: bold;
}
.success {
  color: var(--text-success);
}
.warning {
  color: var(--text-warning);
}
.danger {
  color: var(--text-danger);
}
.expired {
  animation-name: expired;
  animation-duration: 500ms;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
</style>
